export default "__VITE_ASSET__BgGUk4fi__"